/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Projects_BlurbInputs */



/**
* | output |
* | --- |
* | "Projects are your AI workspaces. Each organizes its own chats, instructions, and file references, keeping different teams, clients, or use cases cleanly sepa..." |
*
* @param {Uno_Edu_Intro_Projects_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_projects_blurb = /** @type {((inputs?: Uno_Edu_Intro_Projects_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Projects_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekte sind Ihre KI-Arbeitsbereiche. Jedes organisiert eigene Chats, Anweisungen und Dateireferenzen und hält verschiedene Teams, Kunden oder Anwendungsfälle sauber getrennt.")
	return /** @type {LocalizedString} */ ("Projects are your AI workspaces. Each organizes its own chats, instructions, and file references, keeping different teams, clients, or use cases cleanly separated.")
});